import React, { useContext, useEffect } from "react";

import {
  FormTransferAsset,
  getTfListById,
  RESET_STATE_TRANSFER_ASSET,
} from "./ui";
import { STYLE_DEFAULT_MASTER, WMS_FA_TRANSFER_ASSET } from "App/constants";
import { FormContext, FormProvider } from "./context/FormContext";
import { isNull } from "App/utils/helpers";
import Title from "App/Component/ui/title/Title";
import { Paper } from "@material-ui/core";

export default function TransferAsset(props) {
  const classes = STYLE_DEFAULT_MASTER();
  const dataTFA = isNull(props?.data) ? RESET_STATE_TRANSFER_ASSET : props?.menu === WMS_FA_TRANSFER_ASSET ? props?.data : RESET_STATE_TRANSFER_ASSET
  return (
    <FormProvider
      data={dataTFA}
    >
      <div className={classes.root}>
        <Title title={"Transfer Asset"} />
        <Paper className={classes.paper}>
          <RenderContent classes={classes} data={dataTFA} />
        </Paper>
      </div>
    </FormProvider>
  );
}
const RenderContent = ({ classes, data }) => {
  const { formData, setFormData, listTF, setListTF } = useContext(FormContext);

  useEffect(() => {
    setNewDataTFList(data.id);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps
  const setNewDataTFList = async (idTf) => {
    if (!isNull(data)) {
      await getListTf(data.id);
    } else if (!isNull(idTf)) {
      await getListTf(idTf);
    }
  };

  const getListTf = async (idTf) => {
    if (!isNull(idTf)) {
      const res = await getTfListById(idTf);
      if (res.state) {
        setFormData(res.data);
        setListTF(res.list);
      } else {
        setFormData(RESET_STATE_TRANSFER_ASSET);
        setListTF([]);
      }
    }
  };

  return (
    <div className={classes.root}>
      <FormTransferAsset
        formData={formData}
        setFormData={setFormData}
        classes={classes}
        setNewData={setNewDataTFList}
        listTF={listTF}
        setListTF={setListTF}
      />
    </div>
  );
};
